import {
  RedBlock,
  Airplane,
  Bus,
  Divider,
  Food,
  Keys,
  Recomended,
  YDivider,
} from '../../cmps/ui/elements/japanguide'
import { JapanTripHelmet } from '../../cmps/Helments/JapanTripHelmet'
import { CityInfo } from '../../cmps/JapanGuide/CityInfo'
import { SeasonsSelector } from '../../cmps/JapanGuide/SeasonsSelector'
import { RedDivider } from '../../cmps/RedDivider'
import { images, japanImages } from '../../services/images.service'

export function JapanTrip() {
  return (
    <section className="container mx-auto p-2">
      <JapanTripHelmet />
      <div className="flex flex-col items-center justify-center">
        <img src={japanImages.banner} alt="Japan Banner" title="Japan Banner" />

        <div className="flex flex-col max-w-[800px] gap-3 lg:gap-10 justify-center items-center mt-6 lg:mt-20 text-center">
          <h1 className="text-2xl lg:text-[45px] text-white">המסע ליפן</h1>
          <p className="lg:text-lg">
            כל חובב אנימה ומנגה בשלב מסוים התעניין בטיול ליפן, אך הרוב מהססים
            מחוסר ידע, לכן הכנו לכם את הכתבה הזאת שתכין אתכם לטיול המושלם! פה
            תלמדו כל מה שתצטרכו לקראת הטיול שלכם ליפן.
          </p>
        </div>
      </div>

      {/* למה יפן */}

      <div className="flex flex-col lg:flex-row">
        <div className="flex flex-col gap-8">
          <img
            src={japanImages.airwithpin}
            alt="Airplane with pin"
            title="Airplane with pin"
          />
          <div className="flex flex-col gap-8 w-[350px] lg:w-[450px]">
            <h2 className="text-white text-4xl">למה יפן?</h2>
            <p>
              יפן היא מדינה שמשלבת ישן וחדש בצורה מדהימה – ערים מלאות חיים לצד
              מקדשים עתיקים, טבע עוצר נשימה ואוכל שאין בשום מקום אחר. בכל פינה
              יש חוויה מיוחדת, בין אם זה הרחובות המוארים של טוקיו, השקט של קיוטו
              או הנוף המטורף של הר פוג'י. הכל מסודר, נקי ומדויק, והאווירה פשוט
              מיוחדת במינה – כזו שאין בשום מקום אחר בעולם.
            </p>
          </div>
        </div>
        <div className="w-full flex justify-center mt-20">
          <div className="relative w-[320px] h-[400px] sm:w-[400px] sm:h-[500px] md:w-[500px] md:h-[600px]">
            {/* תמונה 1 - למעלה בצד שמאל */}
            <img
              className="absolute top-0 left-0 w-[150px] h-[150px] sm:w-[180px] sm:h-[180px] md:w-[250px] md:h-[250px] z-10 shadow-lg rounded-lg"
              src={japanImages.card1}
              alt="Card 1"
            />

            {/* תמונה 2 - באמצע בצד ימין */}
            <img
              className="absolute top-20 right-0 w-[160px] h-[160px] sm:w-[190px] sm:h-[190px] md:w-[270px] md:h-[270px] z-20 shadow-lg rounded-lg"
              src={japanImages.card2}
              alt="Card 2"
            />

            {/* תמונה 3 - נמוך יותר מצד שמאל */}
            <img
              className="absolute top-40 left-5 w-[170px] h-[170px] sm:w-[200px] sm:h-[200px] md:w-[280px] md:h-[280px] z-0 shadow-lg rounded-lg opacity-80"
              src={japanImages.card3}
              alt="Card 3"
            />

            {/* תמונה 4 - הכי נמוך בצד ימין */}
            <img
              className="absolute bottom-0 right-5 w-[180px] h-[180px] sm:w-[220px] sm:h-[220px] md:w-[300px] md:h-[300px] z-[-1] shadow-lg rounded-lg opacity-70"
              src={japanImages.card4}
              alt="Card 4"
            />
          </div>
        </div>
      </div>
      <div>
        {/* כמה ארוך צריך להיות הטיול? */}

        <div className="flex flex-col items-center justify-center">
          <YDivider />
          <div className="">
            <div className="flex flex-col gap-3 lg:gap-10 justify-center items-center mt-6 lg:mt-20 text-center">
              <h1 className="text-2xl lg:text-[45px] text-white">
                כמה ארוך צריך להיות הטיול?
              </h1>
              <p className="lg:text-lg">
                אורך הטיולים שלכם מאוד תלוי בכם, אבל הנה ההצעות שלנו:
              </p>
            </div>
            <div className="flex md:flex-row flex-col md:gap-10 justify-start items-start gap-0 md:overflow-visible overflow-x-auto snap-x snap-mandatory w-full">
              {/* עמודה 1 */}
              <div className="flex-shrink-0 snap-center flex justify-center items-center w-full md:w-[383px] px-[71px] py-[66px]">
                <div className=" flex flex-col justify-center gap-10 items-center text-center">
                  <div className=" flex flex-col gap-5">
                    <h3 className="text-2xl text-primary">1-</h3>
                    <h3 className="text-2xl text-white">פחות משבוע</h3>
                  </div>
                  <p>
                    מתאים לאנשים שמעוניינים לבקר בעיר אחת בלבד (לדוגמה טוקיו).
                  </p>
                </div>
              </div>
              {/* עמודה 2 */}
              <div className="flex-shrink-0 snap-center flex justify-center items-center w-full md:w-[383px] px-[71px] py-[66px]">
                <div className="flex flex-col justify-center gap-10 items-center text-center">
                  <div className=" flex flex-col gap-5">
                    <h3 className="text-2xl text-primary">2+</h3>
                    <h3 className="text-2xl text-white">שבועיים</h3>
                  </div>
                  <p>
                    כמות הזמן המומלצת, מספיק זמן לחוות את הלוקיישנים המרכזיים
                    כמו טוקיו, קיוטו ואוסקה, ואפילו יום או שניים נוספים למקומות
                    קטנים יותר.
                  </p>
                  <div className="mt-[-20px]">
                    <Recomended />
                  </div>
                </div>
              </div>
              {/* עמודה 3 */}
              <div className="flex-shrink-0 snap-center flex justify-center items-center w-full md:w-[383px] px-[71px] py-[66px]">
                <div className="flex flex-col justify-center gap-10 items-center text-center">
                  <div className=" flex flex-col gap-5">
                    <h3 className="text-2xl text-primary">3+</h3>
                    <h3 className="text-2xl text-white">שלושה שבועות ומעלה</h3>
                  </div>
                  <p>
                    כמות הזמן המושלמת למעוניינים בערים הגדולות וגם באזורים הפחות
                    מתוירים כמו הוקאידו ואוקינאווה.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* מה צריך להיות התקציב שלי? */}
        <div className="flex flex-col items-center justify-center">
          <YDivider />
          <div className="flex flex-col max-w-[800px] gap-3 lg:gap-10 justify-center items-center mt-6 lg:mt-20 text-center">
            <h1 className="text-2xl lg:text-[45px] text-white">
              מה צריך להיות התקציב שלי?
            </h1>
            <p className="lg:text-lg">
              יפן עצמה אמנם לא יקרה מדי אבל צריך להסתכל גם על המסביב.
            </p>
          </div>

          <div className="lg:flex gap-12 w-[330px] lg:w-[1200px] mt-10">
            <div className="lg:w-[600px]">
              <div className="flex gap-6 justify-center items-center lg:justify-start">
                <Keys />
                <h3 className="text-2xl text-white">לינה</h3>
              </div>
              <div className="hidden lg:block">
                <Divider />
              </div>
              <div className="bg-secondaryBackground my-2">
                <div className=" flex justify-center items-center h-[100px]">
                  <p className="text-lg text-center my-12">
                    מחיר לינה ללילה יהיה תלוי בעיר שתהיו בה וברמת החוויה שתרצו,
                    דוגמאות:
                  </p>
                </div>

                <div className="w-full  flex flex-col gap-16 items-center">
                  <div className="flex w-full flex-col justify-center items-center gap-6">
                    <p className="text-primary text-lg bg-background w-[500px] py-2 text-center">
                      טוקיו
                    </p>

                    <div className="w-[400px] flex gap-7 lg:gap-12 justify-center items-center">
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          חסכוני
                        </h6>
                        <h5 className="text-white text-lg">₪100 - ₪250</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          ממוצע
                        </h6>
                        <h5 className="text-white text-lg">₪100 - ₪250</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          יוקרתי
                        </h6>
                        <h5 className="text-white text-lg">₪700 ומעלה</h5>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-center gap-6">
                    <p className="text-primary bg-background w-[500px] py-2 text-center text-lg">
                      אוסאקה
                    </p>

                    <div className="w-[400px] flex gap-7 lg:gap-12 justify-center items-center">
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          חסכוני
                        </h6>
                        <h5 className="text-white text-lg">₪80 - ₪200</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          ממוצע
                        </h6>
                        <h5 className="text-white text-lg">₪250 - ₪500</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          יוקרתי
                        </h6>
                        <h5 className="text-white text-lg">₪600 ומעלה</h5>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-center gap-6">
                    <p className="text-primary bg-background w-[500px] py-2 text-center text-lg">
                      הוקאידו
                    </p>

                    <div className="w-[400px] flex gap-7 lg:gap-12 justify-center items-center">
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          חסכוני
                        </h6>
                        <h5 className="text-white text-lg">₪90 - ₪220</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          ממוצע
                        </h6>
                        <h5 className="text-white text-lg">₪280 - ₪550</h5>
                      </div>
                      <div>
                        <h6 className="text-muted text-sm text-center">
                          יוקרתי
                        </h6>
                        <h5 className="text-white text-lg">₪700 ומעלה</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-10 hidden lg:block">
                  <RedBlock />
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-12">
              <div>
                <div className="flex gap-6 justify-center items-center lg:justify-start">
                  <Airplane />
                  <h3 className="text-2xl text-white">טיסה</h3>
                </div>
                <div className="hidden lg:block mb-5">
                  <Divider />
                </div>
                <div className="flex bg-secondaryBackground h-full px-4 flex-col justify-center items-center lg:items-start">
                  <h5 className="text-lg">מחיר טיסה ממוצע</h5>
                  <h3 className="text-2xl text-white">₪3000 - ₪5500</h3>
                  <span className="text-muted text-sm mt-4">
                    (תלוי בעונה ובחברת תעופה)
                  </span>
                </div>
              </div>
              <div className="w-full my-11 hidden lg:block">
                <img className="w-full" src={images.redDivider} alt="Divider" />
              </div>
              <div>
                <div className="flex gap-6 justify-center items-center lg:justify-start">
                  <Bus />
                  <h3 className="text-2xl text-white">תחבורה</h3>
                </div>
                <div className="hidden lg:block mb-5">
                  <Divider />
                </div>
                <div className="flex bg-secondaryBackground h-full px-4 flex-col justify-center items-center gap-7">
                  <p>
                    כרטיס חד פעמי למטרו (נסיעה בתוך העיר) יעלה בין 5₪ ל10₪
                    וכרטיס לרכבת המהירה (נסיעה בין ערים) יעלה בין 400₪ ל900₪
                    תלוי באזורים.
                  </p>
                </div>
              </div>
              <div className="w-full my-11 hidden lg:block">
                <img className="w-full" src={images.redDivider} alt="Divider" />
              </div>

              <div>
                <div className="flex gap-6 justify-center items-center lg:justify-start">
                  <Food />
                  <h3 className="text-2xl text-white">אוכל</h3>
                </div>
                <div className="hidden lg:block mb-5">
                  <Divider />
                </div>
                <div className="flex bg-secondaryBackground h-full px-4 flex-col justify-center items-center gap-7">
                  <p>
                    אוכל ביפן יכול להיות מאוד זול, אבל כמובן תלוי מאיפה אוכלים,
                    המקומות הזולים ביותר יכולים להיות אפילו עד 20₪ למנה!
                  </p>
                  <p>
                    ארוחה במסעדה ממוצעת יכולה לעלות בין 80₪ ל150₪. וכמובן יש את
                    המסעדות היוקרתיות שלא מומלץ לפספס! שם ארוחה תעלה בין 200₪
                    ל500₪.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* איפה לבקר? */}

      <div className="flex flex-col items-center mt-[200px] text-center">
        <div className="mb-10">
          <YDivider />
        </div>
        <h2 className="text-4xl text-white">איפה לבקר?</h2>
        <p className="text-lg mt-8">
          אז לפני שאנחנו בוחרים מקומות לבקר בהם אנחנו צריכים לבחור את הערים בהם
          נשהה רוב הזמן.
        </p>
        <p className="text-primary text-lg mt-20">אז איך בוחרים?</p>
        <h2 className="text-4xl w-[300px] lg:w-[450px] text-white mt-8">
          ביפן כמו ברוב מדינות העולם יש מקומות שהכי כדאי לבקר בהם בעונות
          ספציפיות.
        </h2>

        <div className="mt-10">
          <SeasonsSelector />
        </div>

        <div className="my-36">
          <YDivider />
        </div>
        <div className="mt-10">
          <CityInfo />
        </div>
      </div>
    </section>
  )
}
